// extracted by mini-css-extract-plugin
module.exports = {"circle-background":"mjPla","circle-progress":"_3AVvz","circle-text":"y4nES"};